import { FC, useEffect } from 'react';

import { ModalHelp } from '@components/modal-help';
import { ContainerToken } from '@containers/container-token';
import { IToken } from '@interface/token';
import * as DialogPrimitive from '@radix-ui/react-dialog';

import * as Styles from './styles';

interface IContextualTokenModal {
  visible: boolean;
  token: IToken;
  onChange: (increment: number) => void;
  onClose: () => void;
}

export const ContextualTokenModal: FC<IContextualTokenModal> = ({
  visible = false,
  token,
  onChange = () => null,
  onClose = () => null,
}) => {
  const handleKey = (e: KeyboardEvent) => {
    if (e.key === 'ArrowLeft') {
      onChange(-1);
    }
    if (e.key === 'ArrowRight') {
      onChange(+1);
    }
  };

  useEffect(() => {
    if (visible) {
      // document.body.style.overflow = 'hidden';
      document.body.classList.add('lock');
    } else {
      // document.body.style.overflow = 'unset';
      document.body.classList.remove('lock');
    }
  }, [visible]);

  useEffect(() => {
    window.addEventListener('keyup', handleKey);
    return () => {
      window.removeEventListener('keyup', handleKey);
    };
  });

  if (!token) {
    return null;
  }

  return (
    <DialogPrimitive.Root open={visible} onOpenChange={onClose} allowPinchZoom>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay asChild>
          <Styles.Overlay>
            <DialogPrimitive.Content asChild onPointerDownOutside={(e) => e.preventDefault()}>
              <Styles.Content>
                <DialogPrimitive.Close asChild>
                  <Styles.Close>
                    <i>close</i>
                  </Styles.Close>
                </DialogPrimitive.Close>
                <Styles.Scrollable>
                  <Styles.Container>
                    <ContainerToken token={token} />
                    <ModalHelp />
                  </Styles.Container>
                </Styles.Scrollable>
              </Styles.Content>
            </DialogPrimitive.Content>
          </Styles.Overlay>
        </DialogPrimitive.Overlay>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};
